import '../../monitoring/filters/keyword/applied_keywords_view.js.coffee'

class Profiling.Dashboard.Filters.AppliedKeywordsView extends Monitoring.Views.SocialContents.Filters.AppliedKeywordsView
  _triggerQueryChanged: =>
    @searchQuery.triggerFilterChanged()
